/** @jsxImportSource @emotion/react */
import { Col, Container, ListGroup, ListGroupItem, Row } from "reactstrap";
import { ClientPortalProvider, useClientPortal } from "../../../context/ClientPortal";
import FullPageLayout from "../Layout/FullPageLayout";
import StyledBox from "../Layout/StyledBox";
import Reports from "./Reports";

export const ClientPortal = () => (
    <ClientPortalProvider>
        <ClientPortalPage />
    </ClientPortalProvider>
);

export const ClientPortalPage = () => {
    const { tenants, onTenantSelect, selectedTenant } = useClientPortal();

    return (
        <FullPageLayout>
            <Container className="py-md-5 py-3">
                <Row className="g-5">
                    <Col xs="3" sm="3" md="2" className="border-right py-4">
                        <ListGroup>
                            {tenants?.map((tenant, index) => (
                                <ListGroupItem
                                    key={index}
                                    tag="button"
                                    action
                                    onClick={() => onTenantSelect(tenant)}
                                    active={
                                        tenant.id === selectedTenant?.id
                                        && tenant?.client_id === selectedTenant?.client_id
                                    }
                                >
                                    {tenant.label}
                                </ListGroupItem>
                            ))}
                        </ListGroup>
                    </Col>

                    <Col xs="9" sm="9" md="10">
                        <StyledBox>
                            <h4 className="text-muted fs-6 fw-bold border-bottom pb-2 mb-4">Reports</h4>

                            <Reports />
                        </StyledBox>
                    </Col>
                </Row>
            </Container>
        </FullPageLayout>
    );
};
